import { intersect, literal, partial, struct, union } from 'io-ts/Decoder';

import { Request as SearchRequest } from '../../../../report/design-transactions/Request';
import { Request as DefiniteRequest } from '../../../generic/pagination/definite/Request';

/**
 * Report pagination is always a definite request on the wire (backend reads
 * from/size directly). An optional `scrollStyle` field rides along so the client
 * can remember whether to render infinite-scroll or a paginator.
 */
const PaginationRequest = intersect(DefiniteRequest)(
	partial({
		scrollStyle: union(literal('infinite'), literal('paged')),
	})
);

export const Request = intersect(SearchRequest)(
	struct({
		pagination: PaginationRequest,
	})
);
